export default __webpack_public_path__ + "static/media/KOD0052-min.6ee462cc.webp";